import { EnumWithDescription, ICustomEnumValue } from "./EnumWithDescription";

export enum HCDisciplineEnum {
    "None" = 0,
    "Nursing" = 1,
    "Orders" = 2,
    "PT" = 3,
    "OT" = 4,
    "ST" = 5,
    "HHA" = 6,
    "MSW" = 7,
    "Dietician" = 8,
    "Claim" = 9,
    "ReportsAndNotes" = 10
}

class HCDisciplineClass extends EnumWithDescription<HCDisciplineEnum> {
    public readonly enum = HCDisciplineEnum;
    public readonly enumName: string = "HCDisciplineEnum";
    public readonly enumWithDescriptions: Map<string, ICustomEnumValue<HCDisciplineEnum>> = new Map([
        [
            "Nursing",
            {
                name: "Nursing",
                value: 1
            }
        ],
        [
            "Orders",
            {
                name: "Orders",
                value: 2
            }
        ],
        [
            "PT",
            {
                name: "PT",
                value: 3
            }
        ],
        [
            "OT",
            {
                name: "OT",
                value: 4
            }
        ],
        [
            "ST",
            {
                name: "ST",
                value: 5
            }
        ],
        [
            "HHA",
            {
                name: "HHA",
                value: 6
            }
        ],
        [
            "MSW",
            {
                name: "MSW",
                value: 7
            }
        ],
        [
            "Dietician",
            {
                name: "Dietician",
                value: 8
            }
        ]
    ]);
}

export const HCDiscipline = new HCDisciplineClass();
